import React, { useCallback } from 'react';
import moment from 'moment';
import { useObservableState } from 'observable-hooks';
import { map } from 'rxjs/operators';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { INTERNAL_ARTICLES_VIEW } from '../../../router/routes';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import Article from '../../../interfaces/article';
import Form, { SubmitType } from '../../../components/form';
import Button from '../../../components/form/elements/button';
import Link from '../../../components/form/elements/link';
import useArticleForm, { articleSchema } from './use-article-form';

export default function EditArticle() {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { articleService } = useService();
  const body = useArticleForm();
  const footer = [
    Button('save'),
    Link(route(INTERNAL_ARTICLES_VIEW, { id }), 'cancel'),
  ];

  const [article] = useObservableState<Article>(
    () =>
      articleService.show(id).pipe(
        map((article) => {
          return {
            ...article,
            created_at: moment(article.created_at).format('DD.MM.YYYY'),
          };
        })
      ),
    null
  );

  const submit = useCallback<SubmitType<Article>>(
    (form) => [
      articleService.update(id, form),
      (response) =>
        history.push(route(INTERNAL_ARTICLES_VIEW, { id: response.id })),
    ],
    [id, articleService, history]
  );

  return (
    <Form
      title={article ? article.title : t('pages.internal.articles.form.create')}
      mode={'edit'}
      body={body}
      footer={footer}
      values={article}
      submit={submit}
      schema={articleSchema}
    />
  );
}
